// extracted by mini-css-extract-plugin
export default {"overlayWithSpinner":"overlayWithSpinner_overlayWithSpinner__b4MJU","spinner":"overlayWithSpinner_spinner__-ydNo"};